export default __webpack_public_path__ + "media/images/app-icon-082c534d2e31302aae0209c75d72adc5.svg";